/** True while react-snap's puppeteer (user agent contains ReactSnap) is saving HTML. */
export function isReactSnapUserAgent(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('ReactSnap');
}

/**
 * True on a visitor's first render of a document react-snap already filled.
 * Evaluated at call time. During the crawl the root is still empty when the
 * app module loads, and the crawler user agent is excluded, so the snapshot
 * itself is not forced onto the hydrated animation state.
 */
export function isHydratingPrerenderedDocument(): boolean {
  if (typeof document === 'undefined') return false;
  if (isReactSnapUserAgent()) return false;
  const root = document.getElementById('root');
  return !!root && root.hasChildNodes();
}
